<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13sK0kv/tc-custom/9780226583525.jpg?1722571970581" alt="This image is the cover for the book Recipes and Everyday Knowledge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Recipes and Everyday Knowledge
      </h1>
      <p class="bookDescription body article font2">
        <p>Across early modern Europe, men and women from all ranks gathered medical, culinary, and food preservation recipes from family and friends, experts and practitioners, and a wide array of printed materials. Recipes were tested, assessed, and modified by teams of householders, including masters and servants, husbands and wives, mothers and daughters, and fathers and sons. This much-sought know-how was written into notebooks of various shapes and sizes forming “treasuries for health,” each personalized to suit the whims and needs of individual communities.<br/>  <br/> In <i>Recipes and Everyday Knowledge</i>, Elaine Leong situates recipe knowledge and practices among larger questions of gender and cultural history, the history of the printed word, and the history of science, medicine, and technology. The production of recipes and recipe books, she argues, were at the heart of quotidian investigations of the natural world or “household science”. She shows how English homes acted as vibrant spaces for knowledge making and transmission, and explores how recipe trials allowed householders to gain deeper understandings of sickness and health, of the human body, and of natural and human-built processes. By recovering this story, Leong extends the parameters of natural inquiry and productively widens the cast of historical characters participating in and contributing to early modern science.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elaine Leong
      </h2>
      
      <p class="authorDescription body article"><B>Elaine Leong</B>&#160;is a Minerva Research Group Leader at the Max Planck Institute for the History of Science, Berlin.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ec0b1e20